import React, { useEffect } from "react";
import { useLazyGetAssetsFinalFilteredQuery } from "../../../features/addassets/addassetfinalApiSlice";


const FilteredAssetsFetcher = ({ filters, onDataFetched }) => {
  const [fetchAssets, { data, isLoading }] = useLazyGetAssetsFinalFilteredQuery();

  useEffect(() => {
    // Always fetch data - backend handles permission filtering
    fetchAssets({ page: 1, limit: 99999, filters });
  }, [filters]);

  useEffect(() => {
    if (data && onDataFetched) {
      onDataFetched(data);
    }
  }, [data]);

  return null; // no UI rendered
};

export default FilteredAssetsFetcher;